import React from "react";
import Hero from "../components/Hero";
import CabServices from "../components/CabServices";
import OneWayTaxi from "../components/OneWayTaxi";
import TourPackages from "../components/TourPackages";
import Testimonials from "../components/Testimonials";
import CustomItinerary from "../components/CustomItinerary";

export default function Home() {
  return (
    <>
      <Hero />
      <CabServices />
      <OneWayTaxi />
      <TourPackages />
      <CustomItinerary />
      <Testimonials />
    </>
  );
}
